// extracted by mini-css-extract-plugin
export default {"separate":"Input_separate__AuP69","fast-add-input":"Input_fast-add-input__z69Sh","error":"Input_error__VfYTM"};